import { connectionDataFields } from '../connectionDataFields'

export function setConnectionData (data) {
  if (!this.services[this.serviceIndex].connectionData) this.services[this.serviceIndex].connectionData = connectionDataFields
  Object.assign(this.services[this.serviceIndex].connectionData, data)
}
